import React, { useEffect, useState } from "react";
import "../App.css";

const API_URL = "https://mediumpurple-hamster-254578.hostingersite.com";
const USUARIO_BACKOFFICE = "quimsaacreditaciones@gmail.com";
const CONTRASENA_BACKOFFICE = "nakata86";

function Backoffice() {
  const [acreditaciones, setAcreditaciones] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [acreditacionSeleccionada, setAcreditacionSeleccionada] =
    useState(null);
  const [cargandoFicha, setCargandoFicha] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorLogin, setErrorLogin] = useState("");

  // =========================================
  // OBTENER ACREDITACIONES
  // =========================================

  const obtenerAcreditaciones = async () => {
    try {
      setCargando(true);
      setError("");

      const response = await fetch(
        `${API_URL}/acreditaciones`
      );

      if (!response.ok) {
        throw new Error(
          "Error al obtener las acreditaciones"
        );
      }

      const data = await response.json();

      setAcreditaciones(data);
    } catch (error) {
      console.error(error);
      setError(
        "No se pudieron cargar las acreditaciones."
      );
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    if (usuario) {
      obtenerAcreditaciones();
    }
  }, [usuario]);

  const ingresar = async (event) => {
    event.preventDefault();
    setErrorLogin("");

    if (email.trim() === USUARIO_BACKOFFICE && password === CONTRASENA_BACKOFFICE) {
      setUsuario({ email: USUARIO_BACKOFFICE });
      return;
    }

    setErrorLogin("El correo o la contraseña no son correctos.");
  };

  const salir = () => {
    setUsuario(null);
    setAcreditaciones([]);
    setAcreditacionSeleccionada(null);
  };

  if (!usuario) {
    return (
      <div className="backoffice-login-page">
        <form className="backoffice-login-card" onSubmit={ingresar}>
          <span className="backoffice-login-label">QUIMSA / BACKOFFICE</span>
          <h1>Iniciar sesión</h1>
          <p>Ingresá para gestionar las acreditaciones de prensa.</p>

          <label htmlFor="backoffice-email">Correo electrónico</label>
          <input
            id="backoffice-email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            autoComplete="email"
            required
          />

          <label htmlFor="backoffice-password">Contraseña</label>
          <input
            id="backoffice-password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />

          {errorLogin && <div className="backoffice-login-error">{errorLogin}</div>}

          <button type="submit" className="backoffice-login-button">
            Ingresar
          </button>
        </form>
      </div>
    );
  }

  // =========================================
  // ESTADÍSTICAS
  // =========================================

  const pendientes = acreditaciones.filter(
    (item) => item.estado === "pendiente"
  ).length;

  const aprobadas = acreditaciones.filter(
    (item) => item.estado === "aprobada"
  ).length;

  const rechazadas = acreditaciones.filter(
    (item) => item.estado === "rechazada"
  ).length;

  const total = acreditaciones.length;

  // =========================================
  // ABRIR FICHA
  // =========================================

  const verAcreditacion = async (acreditacion) => {
    try {
      setCargandoFicha(true);

      // Primero mostramos la información que ya tenemos
      setAcreditacionSeleccionada(acreditacion);

      // Luego buscamos el detalle completo
      const response = await fetch(
        `${API_URL}/acreditaciones/${acreditacion.id}`
      );

      if (!response.ok) {
        throw new Error(
          "No se pudo obtener el detalle"
        );
      }

      const detalle = await response.json();

      setAcreditacionSeleccionada({
        ...acreditacion,
        ...detalle,
      });
    } catch (error) {
      console.error(
        "Error obteniendo detalle:",
        error
      );

      // Si falla el detalle, dejamos igualmente
      // abierta la información disponible.
    } finally {
      setCargandoFicha(false);
    }
  };

  // =========================================
  // CERRAR FICHA
  // =========================================

  const cerrarFicha = () => {
    setAcreditacionSeleccionada(null);
  };

  // =========================================
  // CAMBIAR ESTADO
  // =========================================

  const cambiarEstado = async (
    id,
    nuevoEstado
  ) => {
    try {
      const confirmar = window.confirm(
        nuevoEstado === "aprobada"
          ? "¿Estás seguro de que querés APROBAR esta acreditación?"
          : "¿Estás seguro de que querés RECHAZAR esta acreditación?"
      );

      if (!confirmar) {
        return;
      }

      const response = await fetch(
        `${API_URL}/acreditaciones/${id}/estado`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            estado: nuevoEstado,
          }),
        }
      );

      if (!response.ok) {
        const data = await response.json().catch(() => null);

        throw new Error(
          data?.mensaje ||
            "No se pudo cambiar el estado"
        );
      }

      // Actualizar tabla
      setAcreditaciones((prev) =>
        prev.map((item) =>
          item.id === id
            ? {
                ...item,
                estado: nuevoEstado,
              }
            : item
        )
      );

      // Actualizar ficha
      setAcreditacionSeleccionada((prev) =>
        prev
          ? {
              ...prev,
              estado: nuevoEstado,
            }
          : null
      );

      alert(
        nuevoEstado === "aprobada"
          ? "Acreditación aprobada correctamente."
          : "Acreditación rechazada correctamente."
      );
    } catch (error) {
      console.error(
        "Error cambiando estado:",
        error
      );

      alert(
        `No se pudo cambiar el estado.\n\n${error.message}`
      );
    }
  };

  // =========================================
  // DESCARGAR FOTO
  // =========================================

  const descargarFoto = async (
    persona,
    fotoPath
  ) => {
    try {
      if (!fotoPath) {
        alert(
          "Esta persona no tiene una foto cargada."
        );
        return;
      }

      if (!acreditacionSeleccionada?.id) {
        alert(
          "No se encontró la acreditación."
        );
        return;
      }

      // Sacamos solamente el nombre del archivo
      const archivo = fotoPath
        .split("/")
        .pop();

      if (!archivo) {
        throw new Error(
          "No se encontró el archivo de la foto."
        );
      }

      // URL del endpoint de descarga
      const url =
        `${API_URL}/acreditaciones/` +
        `${acreditacionSeleccionada.id}/foto/` +
        `${encodeURIComponent(archivo)}/descargar`;

      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(
          "No se pudo descargar la foto."
        );
      }

      const blob =
        await response.blob();

      const urlBlob =
        window.URL.createObjectURL(blob);

      const enlace =
        document.createElement("a");

      enlace.href = urlBlob;

      // Conservamos la extensión original
      const extension =
        archivo.includes(".")
          ? archivo
              .split(".")
              .pop()
              .toLowerCase()
          : "jpg";

      // Limpiamos los datos para el nombre
      const limpiarTexto = (texto) => {
        return String(texto || "")
          .trim()
          .replace(/\s+/g, "_")
          .replace(
            /[^a-zA-Z0-9_-]/g,
            ""
          );
      };

      const nombre =
        limpiarTexto(
          persona?.nombre || "Persona"
        );

      const apellido =
        limpiarTexto(
          persona?.apellido || ""
        );

      const dni =
        limpiarTexto(
          persona?.dni || "SIN_DNI"
        );

      enlace.download =
        `${nombre}_${apellido}_DNI_${dni}.${extension}`;

      document.body.appendChild(
        enlace
      );

      enlace.click();

      enlace.remove();

      window.URL.revokeObjectURL(
        urlBlob
      );
    } catch (error) {
      console.error(
        "Error descargando foto:",
        error
      );

      alert(
        "No se pudo descargar la foto."
      );
    }
  };

  // =========================================
  // RENDER
  // =========================================

  return (
    <div className="backoffice">

      {/* =========================================
          SIDEBAR
      ========================================= */}

      <aside className="backoffice-sidebar">

        <div className="backoffice-logo">
          QUIMSA
          <span>BACKOFFICE</span>
        </div>

        <nav>
          <a href="#dashboard">
            Dashboard
          </a>

          <a href="#acreditaciones">
            Acreditaciones
          </a>

            <button className="backoffice-logout" onClick={salir}>
              Cerrar sesión
            </button>
        </nav>

      </aside>

      {/* =========================================
          CONTENIDO
      ========================================= */}

      <main className="backoffice-main">

        <header className="backoffice-header">

          <div>
            <h1>
              Panel de administración
            </h1>

            <p>
              Gestión de acreditaciones de prensa
            </p>
          </div>

        </header>

        {/* =========================================
            ESTADÍSTICAS
        ========================================= */}

        <section
          className="backoffice-stats"
          id="dashboard"
        >

          <div className="stat-card">
            <span>Pendientes</span>
            <strong>{pendientes}</strong>
          </div>

          <div className="stat-card">
            <span>Aprobadas</span>
            <strong>{aprobadas}</strong>
          </div>

          <div className="stat-card">
            <span>Rechazadas</span>
            <strong>{rechazadas}</strong>
          </div>

          <div className="stat-card">
            <span>Total</span>
            <strong>{total}</strong>
          </div>

        </section>

        {/* =========================================
            ACREDITACIONES
        ========================================= */}

        <section
          className="backoffice-section"
          id="acreditaciones"
        >

          <div className="section-header">

            <div>
              <h2>
                Acreditaciones
              </h2>

              <p>
                Solicitudes recibidas
              </p>
            </div>

            <button
              className="btn-refresh"
              onClick={obtenerAcreditaciones}
              disabled={cargando}
            >
              {cargando
                ? "Cargando..."
                : "Actualizar"}
            </button>

          </div>

          {/* ERROR */}

          {error && (
            <div className="acreditaciones-empty">

              <h3>
                Error
              </h3>

              <p>
                {error}
              </p>

            </div>
          )}

          {/* CARGANDO */}

          {cargando && !error && (
            <div className="acreditaciones-empty">

              <h3>
                Cargando acreditaciones...
              </h3>

              <p>
                Consultando solicitudes.
              </p>

            </div>
          )}

          {/* SIN DATOS */}

          {!cargando &&
            !error &&
            acreditaciones.length === 0 && (
              <div className="acreditaciones-empty">

                <h3>
                  No hay acreditaciones cargadas
                </h3>

                <p>
                  Las solicitudes aparecerán aquí.
                </p>

              </div>
            )}

          {/* TABLA */}

          {!cargando &&
            !error &&
            acreditaciones.length > 0 && (

              <div className="tabla-container">

                <table className="tabla-acreditaciones">

                  <thead>
                    <tr>
                      <th>Medio</th>
                      <th>Tipo</th>
                      <th>Responsable</th>
                      <th>DNI</th>
                      <th>Personas</th>
                      <th>Estado</th>
                      <th>Acción</th>
                    </tr>
                  </thead>

                  <tbody>

                    {acreditaciones.map(
                      (acreditacion) => (

                        <tr
                          key={
                            acreditacion.id
                          }
                        >

                          <td>
                            <strong>
                              {
                                acreditacion.medio
                              }
                            </strong>
                          </td>

                          <td>
                            {
                              acreditacion.medioTipo
                            }
                          </td>

                          <td>
                            {
                              acreditacion
                                .responsable
                                ?.nombre
                            }{" "}
                            {
                              acreditacion
                                .responsable
                                ?.apellido
                            }
                          </td>

                          <td>
                            {
                              acreditacion
                                .responsable
                                ?.dni || "-"
                            }
                          </td>

                          <td>
                            {
                              acreditacion
                                .cantidadPersonas ||
                              1
                            }
                          </td>

                          <td>

                            <span
                              className={
                                `estado estado-${acreditacion.estado}`
                              }
                            >
                              {
                                acreditacion.estado
                              }
                            </span>

                          </td>

                          <td>

                            <button
                              className="btn-ver"
                              onClick={() =>
                                verAcreditacion(
                                  acreditacion
                                )
                              }
                            >
                              Ver ficha
                            </button>

                          </td>

                        </tr>

                      )
                    )}

                  </tbody>

                </table>

              </div>
            )}

        </section>

      </main>

      {/* =========================================
          MODAL / FICHA
      ========================================= */}

      {acreditacionSeleccionada && (

        <div
          className="modal-overlay"
          onClick={cerrarFicha}
        >

          <div
            className="modal-acreditacion"
            onClick={(e) =>
              e.stopPropagation()
            }
          >

            {/* HEADER */}

            <div className="modal-header">

              <div>

                <span className="modal-etiqueta">
                  SOLICITUD DE ACREDITACIÓN
                </span>

                <h2>
                  {
                    acreditacionSeleccionada.medio
                  }
                </h2>

                <p>
                  Temporada 2026 / 2027
                </p>

              </div>

              <button
                className="modal-cerrar"
                onClick={cerrarFicha}
              >
                ×
              </button>

            </div>

            {/* CARGANDO DETALLE */}

            {cargandoFicha && (
              <div className="mensaje-estado">
                Cargando información completa...
              </div>
            )}

            {/* ESTADO */}

            <div className="modal-estado">

              <span>
                Estado de solicitud
              </span>

              <strong
                className={
                  `estado estado-${acreditacionSeleccionada.estado}`
                }
              >
                {
                  acreditacionSeleccionada.estado
                }
              </strong>

            </div>

            {/* INFORMACIÓN DEL MEDIO */}

            <div className="ficha-seccion">

              <h3>
                Información del medio
              </h3>

              <div className="ficha-grid">

                <div className="ficha-dato">
                  <span>
                    Medio
                  </span>

                  <strong>
                    {
                      acreditacionSeleccionada.medio ||
                      "-"
                    }
                  </strong>
                </div>

                <div className="ficha-dato">
                  <span>
                    Tipo de medio
                  </span>

                  <strong>
                    {
                      acreditacionSeleccionada.medioTipo ||
                      "-"
                    }
                  </strong>
                </div>

                <div className="ficha-dato">
                  <span>
                    Email
                  </span>

                  <strong>
                    {
                      acreditacionSeleccionada.emailMedio ||
                      "-"
                    }
                  </strong>
                </div>

                <div className="ficha-dato">
                  <span>
                    Teléfono
                  </span>

                  <strong>
                    {
                      acreditacionSeleccionada.telefono ||
                      "-"
                    }
                  </strong>
                </div>

              </div>

            </div>

            {/* RESPONSABLE */}

            <div className="ficha-seccion">

              <h3>
                Responsable de la acreditación
              </h3>

              <div className="responsable-ficha">

                {/* FOTO */}

                <div className="foto-responsable">

                  {acreditacionSeleccionada
                    .responsable
                    ?.fotoPath ? (

                   <img
  src={`${API_URL}/acreditaciones/${
    acreditacionSeleccionada.id
  }/foto/${
    acreditacionSeleccionada.responsable.fotoPath
      .split("/")
      .pop()
  }`}
  alt="Foto del responsable"
/>

                  ) : (

                    <div className="sin-foto">
                      Sin foto
                    </div>

                  )}

                </div>

                {/* DATOS */}

                <div className="ficha-grid ficha-grid-responsable">

                  <div className="ficha-dato">
                    <span>
                      Nombre
                    </span>

                    <strong>
                      {
                        acreditacionSeleccionada
                          .responsable
                          ?.nombre || "-"
                      }{" "}
                      {
                        acreditacionSeleccionada
                          .responsable
                          ?.apellido || ""
                      }
                    </strong>
                  </div>

                  <div className="ficha-dato">
                    <span>
                      DNI
                    </span>

                    <strong>
                      {
                        acreditacionSeleccionada
                          .responsable
                          ?.dni || "-"
                      }
                    </strong>
                  </div>

                  <div className="ficha-dato">
                    <span>
                      Función
                    </span>

                    <strong>
                      {
                        acreditacionSeleccionada
                          .responsable
                          ?.funcion || "-"
                      }
                    </strong>
                  </div>

                  <div className="ficha-dato">
                    <span>
                      Email personal
                    </span>

                    <strong>
                      {
                        acreditacionSeleccionada
                          .responsable
                          ?.email || "-"
                      }
                    </strong>
                  </div>

                  <div className="ficha-dato">
                    <span>
                      Teléfono personal
                    </span>

                    <strong>
                      {
                        acreditacionSeleccionada
                          .responsable
                          ?.telefono || "-"
                      }
                    </strong>
                  </div>

                </div>

              </div>

              {/* BOTÓN DESCARGAR */}

              {acreditacionSeleccionada
                .responsable
                ?.fotoPath && (

                <button
                  className="btn-descargar-foto"
                  onClick={() =>
                    descargarFoto(
                      acreditacionSeleccionada.responsable,
                      acreditacionSeleccionada
                        .responsable
                        .fotoPath
                    )
                  }
                >
                  ⬇ Descargar foto del responsable
                </button>

              )}

            </div>

            {/* =========================================
                INTEGRANTES
            ========================================= */}

            {acreditacionSeleccionada.personas &&
              acreditacionSeleccionada.personas.length >
                0 && (

                <div className="ficha-seccion">

                  <h3>
                    Integrantes solicitados
                  </h3>

                  <div className="integrantes-ficha">

                    {acreditacionSeleccionada.personas.map(
                      (persona, index) => (

                        <div
                          className="integrante-ficha"
                          key={
                            persona.id ||
                            index
                          }
                        >

                          <div className="integrante-foto">

                            {persona.fotoPath ? (

                             <img
  src={`${API_URL}/acreditaciones/${
    acreditacionSeleccionada.id
  }/foto/${
    persona.fotoPath
      .split("/")
      .pop()
  }`}
  alt={`${persona.nombre || ""} ${persona.apellido || ""}`}
/>

                            ) : (

                              <div className="sin-foto">
                                Sin foto
                              </div>

                            )}

                          </div>

                          <div className="integrante-datos">

                            <h4>
                              {
                                persona.nombre
                              }{" "}
                              {
                                persona.apellido
                              }
                            </h4>

                            <p>
                              <strong>
                                DNI:
                              </strong>{" "}
                              {
                                persona.dni ||
                                "-"
                              }
                            </p>

                            <p>
                              <strong>
                                Función:
                              </strong>{" "}
                              {
                                persona.funcion ||
                                "-"
                              }
                            </p>

                            {persona.email && (
                              <p>
                                <strong>
                                  Email:
                                </strong>{" "}
                                {
                                  persona.email
                                }
                              </p>
                            )}

                            {persona.fotoPath && (

                              <button
                                className="btn-descargar-foto"
                                onClick={() =>
                                  descargarFoto(
                                    persona,
                                    persona.fotoPath
                                  )
                                }
                              >
                                ⬇ Descargar foto
                              </button>

                            )}

                          </div>

                        </div>

                      )
                    )}

                  </div>

                </div>

              )}

            {/* CANTIDAD */}

            <div className="ficha-seccion">

              <h3>
                Personal solicitado
              </h3>

              <div className="cantidad-personas">

                <strong>
                  {
                    acreditacionSeleccionada
                      .cantidadPersonas || 1
                  }
                </strong>

                <span>
                  persona
                  {
                    (
                      acreditacionSeleccionada
                        .cantidadPersonas || 1
                    ) !== 1
                      ? "s"
                      : ""
                  }
                </span>

              </div>

            </div>

            {/* ACCIONES */}

            {acreditacionSeleccionada.estado ===
              "pendiente" && (

              <div className="modal-acciones">

                <button
                  className="btn-rechazar"
                  onClick={() =>
                    cambiarEstado(
                      acreditacionSeleccionada.id,
                      "rechazada"
                    )
                  }
                >
                  Rechazar
                </button>

                <button
                  className="btn-aprobar"
                  onClick={() =>
                    cambiarEstado(
                      acreditacionSeleccionada.id,
                      "aprobada"
                    )
                  }
                >
                  Aprobar acreditación
                </button>

              </div>

            )}

            {/* APROBADA */}

            {acreditacionSeleccionada.estado ===
              "aprobada" && (

              <div className="mensaje-estado aprobado">
                ✓ Esta acreditación fue aprobada.
              </div>

            )}

            {/* RECHAZADA */}

            {acreditacionSeleccionada.estado ===
              "rechazada" && (

              <div className="mensaje-estado rechazado">
                Esta acreditación fue rechazada.
              </div>

            )}

          </div>

        </div>

      )}

    </div>
  );
}

export default Backoffice;